export default class CreateVisibilityCtrl {

  constructor ($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, WorkPlanModalSrv, $cookies, GlobalConfig, GlobalSrv) {
    var createVisibilityVm = this
    const texts = GlobalConfig.appTexts
    const listUser = JSON.parse($cookies.get('currentUser'))
    let post = {
      workplanId: listUser.workplanId,
      teacherId: listUser.teacherId,
      name: listUser.name
    }

    createVisibilityVm.listsTypeMediaKind = []
    createVisibilityVm.listsTypeMediaRol = []
    createVisibilityVm.listsTypeMediaFrequencyOfEmission = []
    createVisibilityVm.listsTypeMediaPublicAudience = []
    createVisibilityVm.listsTypeNetworkAssocInterInstitRelatAmbitStage = []
    createVisibilityVm.listsTypeNetworkAssocInterInstitRelatSector = []
    createVisibilityVm.visibilityType = GlobalConfig.visibilityType
    createVisibilityVm.regex = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i
    // createVisibilityVm.regex = /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/

    createVisibilityVm.isEditing = ($stateParams.workplanTeacherActivityId) ? true : false
    createVisibilityVm.rangeType = GlobalConfig.periods.rangeType
    createVisibilityVm.registryType = GlobalConfig.generals.active
    createVisibilityVm.workplanTeacherActivityId = null
    createVisibilityVm.createOrEdit = 'Crear'
    createVisibilityVm.textCreateOrEdit = texts.saved
    createVisibilityVm.createOrEditMV = texts.createDialog
    createVisibilityVm.typePeriod = []
    createVisibilityVm.periodsArray = []
    createVisibilityVm.selectedTypePeriod = {}
    createVisibilityVm.isTouchedPeriods = false
    createVisibilityVm.startDate = null
    createVisibilityVm.endDate = null
    createVisibilityVm.minStartDate = moment().toDate()
    createVisibilityVm.minEndDate = new Date()
    createVisibilityVm.isSaveButtonDisabled = false
    createVisibilityVm.arrayUnit = []
    createVisibilityVm.unitsCombo = []
    createVisibilityVm.isFeedback = listUser.isFeedback
    createVisibilityVm.dt_start = $cookies.get('wp_start')
    createVisibilityVm.dt_end = $cookies.get('wp_end')
    // createVisibilityVm.rolesUnits = rolesUnits

    createVisibilityVm.hasError = hasError
    createVisibilityVm.showErrorMessages = showErrorMessages
    createVisibilityVm.confirmVisibilityAction = confirmVisibilityAction
    createVisibilityVm.validateForm = validateForm
    createVisibilityVm.validateCheklistPeriods = validateCheklistPeriods
    createVisibilityVm.funSelectedPeriod = funSelectedPeriod
    createVisibilityVm.startDateChange = startDateChange
    createVisibilityVm.addVisibility = addVisibility
    createVisibilityVm.close = close
    createVisibilityVm.addOrEditVisibility = addOrEditVisibility
    createVisibilityVm.unitAcademic = unitAcademic
    createVisibilityVm.exists = exists

    createVisibilityVm.updateRangeType = (val) => {
      createVisibilityVm.rangeType = val
      createVisibilityVm.periodsArray = []
      createVisibilityVm.startDate = null
      createVisibilityVm.endDate = null
    }
    createVisibilityVm.updateRangeData = (val) => {
      createVisibilityVm.periodsArray = val['periods']
      createVisibilityVm.startDate = val['dates'][0]
      createVisibilityVm.endDate = val['dates'][1]
    }

    activate()

    function activate () {
      loadContent()
    }

    function loadContent () {
      WorkPlanSrv.getListVisibilityActivities.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            // Primero cargo contenido, y luego consulto si esta editando para setear los valores
            loadData(dataReturn)
            if (createVisibilityVm.isEditing) {
              createVisibilityVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId
              createVisibilityVm.createOrEdit = 'Editar'
              createVisibilityVm.createOrEditMV = texts.editDialog
              createVisibilityVm.textCreateOrEdit = texts.modified
              getDataVisibility()
            }
          } else {
            console.log('Comunications problem')
          }
        },
        data => {
          console.log(data)
        }
      )
    }

    function getDataVisibility () {
      let post = {
        workplanTeacherActivityId: parseInt(createVisibilityVm.workplanTeacherActivityId)
      }
      WorkPlanSrv.getVisibilityActivitiesById.get(post).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          setValues(dataReturn.listVisibility[0])
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {

      })
    }

    function loadData (data) {
      createVisibilityVm.typePeriod = data.listPeriods
      createVisibilityVm.listsTypeMediaKind = data.listVisibilityType.items
      createVisibilityVm.listsTypeMediaRol = data.listVisibilityRole.items
      createVisibilityVm.listsTypeMediaFrequencyOfEmissionType = data.listFrequencyEmission.items
      createVisibilityVm.listsTypeMediaPublicAudience = data.listAudience.items
      createVisibilityVm.listsTypeNetworkAssocInterInstitRelatAmbitStage = data.listAmbit.items
      createVisibilityVm.listsTypeSector = data.listSector.items
      createVisibilityVm.unitsCombo = data.academicUnit
      unitAcademic()
    }

    function unitAcademic () {
      for (var index in createVisibilityVm.unitsCombo) {
        if (!exists(createVisibilityVm.unitsCombo[index].id_code, createVisibilityVm.arrayUnit)) {
          var temp = {
            academitUnitId: createVisibilityVm.unitsCombo[index].id_code,
            academitUnitName: createVisibilityVm.unitsCombo[index].ds_name
          }
          createVisibilityVm.arrayUnit.push(temp)
        }
      }
    }

    function exists (value, array) {
      for (var index in array) {
        if (array[index].id_code == value) {
          return true
        }
      }
      return false
    }

    function hasError (input) {
      if (input && input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input && (input.$dirty || input.$touched)
    }

    function addVisibility (isExecution) {
      let origin = GlobalConfig.activityTypeId.originActivityPlanning
      if (isExecution) {
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function validateForm (form) {
      return (form && form.$invalid) ||
             createVisibilityVm.validateCheklistPeriods()
    }

    function createJson (origin) {
      var visibility = {
        teacherId: post.teacherId,
        workplanId: post.workplanId,
        activityId: GlobalConfig.minorActivityId.visibility,
        nameVisibility: createVisibilityVm.title,
        summary: createVisibilityVm.mediaDescription,
        link: createVisibilityVm.mediaURL,
        hoursPlanning: createVisibilityVm.plannedHours,
        idCommunicationType: createVisibilityVm.mediaKindType,
        idFrequencyEmission: createVisibilityVm.mediaFrequencyOfEmissionType,
        idAudience: createVisibilityVm.mediaPublicAudienceType,
        idRol: createVisibilityVm.mediaRolType,
        origin: origin,
        email: createVisibilityVm.networkAssocInterInstitRelatEmail,
        contact: createVisibilityVm.networkAssocInterInstitRelatContactName,
        idAmbit: createVisibilityVm.networkAssocInterInstitRelatAmbitStageType,
        idSector: createVisibilityVm.networkAssocInterInstitRelatSectorType,
        unit: createVisibilityVm.eventOrganizationUnity,
        timeRangeTypeId: createVisibilityVm.rangeType,
        isFeedbackActivity: createVisibilityVm.isFeedback
      }

      if (createVisibilityVm.isEditing) {
        visibility.workplanTeacherActivityId = createVisibilityVm.workplanTeacherActivityId
      }

      if (createVisibilityVm.rangeType == GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        for (var index in createVisibilityVm.periodsArray) {
          var temp = {
            periodId: createVisibilityVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        visibility.periods = arrayPeriod
      } else {
        visibility.startDate = new Date(createVisibilityVm.startDate)
        visibility.endDate = new Date(createVisibilityVm.endDate)
      }

      // registryType
      for (var i = createVisibilityVm.visibilityType.length - 1; i >= 0; i--) {
        if (createVisibilityVm.visibilityType[i].idVisibility == createVisibilityVm.registryType) {
          visibility.nameCommunicationRegister = createVisibilityVm.visibilityType[i].nameVisibility
        }
      }
      addOrEditVisibility(visibility)
    }

    function addOrEditVisibility (visibility) {
      createVisibilityVm.isSaveButtonDisabled = true
      WorkPlanSrv.addVisibilityActivities.save(visibility).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          getSendNotify(visibility.origin)
          confirmVisibilityAction()
        } else {
          createVisibilityVm.isSaveButtonDisabled = false
          console.log('Error Comunications')
        }
      }, function (data) {
        createVisibilityVm.isSaveButtonDisabled = false
        console.log(data)
      })
    }

    function confirmVisibilityAction () {
      let header = {
        createOrEdit: createVisibilityVm.createOrEditMV,
        textCreateOrEdit: createVisibilityVm.textCreateOrEdit,
        itemName: createVisibilityVm.title,
        nameModal: texts.modalTypeName.visibility,
        modalType: texts.modalTypeId.visibility
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function validateCheklistPeriods () {
      return (createVisibilityVm.rangeType == 1 ? createVisibilityVm.periodsArray.length < 1 : false)
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!createVisibilityVm.periodsArray.includes(period.periodId)) {
          createVisibilityVm.periodsArray.push(period.periodId)
        }
      } else {
        let index = createVisibilityVm.periodsArray.indexOf(period.periodId)
        if (index != -1) {
          createVisibilityVm.periodsArray.splice(index, 1)
        }
      }
      createVisibilityVm.isTouchedPeriods = true
    }

    function startDateChange () {
      let m = moment(createVisibilityVm.startDate)
      createVisibilityVm.minEndDate = m.isValid() ? m/*.add(1, 'days')*/.toDate() : null
    }

    function setValues (visibility) {
      createVisibilityVm.registryType = visibility.registryTypeId
      createVisibilityVm.title = visibility.nameVisibility
      createVisibilityVm.mediaDescription = visibility.summary
      createVisibilityVm.mediaRolType = visibility.idRol
      createVisibilityVm.mediaFrequencyOfEmissionType = visibility.idFrequencyEmission
      createVisibilityVm.mediaPublicAudienceType = visibility.idAudience
      createVisibilityVm.rangeType = visibility.timeRangeTypeId
      createVisibilityVm.eventOrganizationUnity = parseInt(visibility.unit)
      createVisibilityVm.networkAssocInterInstitRelatSectorType = visibility.idSector
      createVisibilityVm.networkAssocInterInstitRelatAmbitStageType = visibility.idAmbit
      createVisibilityVm.networkAssocInterInstitRelatContactName = visibility.contact
      createVisibilityVm.dt_start = moment(visibility.startDate, 'YYYY-MM-DD').toDate()
      createVisibilityVm.dt_end = moment(visibility.endDate, 'YYYY-MM-DD').toDate()
      createVisibilityVm.mediaKindType = visibility.idCommunicationType
      createVisibilityVm.networkAssocInterInstitRelatEmail = visibility.email
      createVisibilityVm.mediaURL = visibility.link
      createVisibilityVm.plannedHours = visibility.hoursPlanned
      createVisibilityVm.periodsArray = []
      createVisibilityVm.selectedTypePeriod = {}

      if (createVisibilityVm.rangeType == GlobalConfig.periods.rangeType) {
        createVisibilityVm.startDate = null
        createVisibilityVm.endDate = null
        var splits = visibility.periodId.split(',')
        if (splits) {
          for (var i = 0; i < splits.length; i++) {
            var valor = splits[i]
            createVisibilityVm.periodsArray.push(parseInt(valor))
            createVisibilityVm.selectedTypePeriod[valor] = true
          }
        }
      }

      for (var i = createVisibilityVm.visibilityType.length - 1; i >= 0; i--) {
        if (createVisibilityVm.visibilityType[i].nameVisibility == visibility.nameCommunicationRegister) {
          createVisibilityVm.registryType = createVisibilityVm.visibilityType[i].idVisibility
        }
      }

      if (visibility.startDate) {
        var startDateNew = moment(visibility.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          createVisibilityVm.minStartDate = moment(visibility.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }

      createVisibilityVm.isEditing = true
    }

    function cleanRangeType () {
      if (parseInt(createVisibilityVm.rangeType) == GlobalConfig.periods.rangeType) {
        createVisibilityVm.startDate = null
        createVisibilityVm.endDate = null
      } else {
        createVisibilityVm.periodsArray = []
        createVisibilityVm.selectedTypePeriod = null
      }
    }

    function close () {
      return $mdDialog.hide()
    }

    function getSendNotify (origin) {
      let msg = 'El profesor ' + listUser.dsFullname + ' ha registrado una nueva actividad en visibilidad en la etapa de '
      if (origin == GlobalConfig.activityTypeId.originActivityExecution)
        msg = msg+'ejecución.'
      else
        msg = msg+'planeación.'

      const data = {
        idTeacher: listUser.teacherId,
        dsName: 'Notificación, se agregó o editó una actividad en visibilidad',
        dsDescription: msg,
        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
        is_grouped: 1
      }
      GlobalSrv.sendNotificationsEvaluatorsSubmodule(data)
    }
  }// FIN DEL CONSTRUCTOR
  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) {
      event.preventDefault()
    }
    return
  }
}

CreateVisibilityCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/extensionVisibility/visibility/create/createVisibilityCtrl.js